import React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

function ItinerarySection({ cruiseDetails }) {
  const { t } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(null);

  const handleAccordionToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  return (
    <section>
      <div className="col-12">
        <h3 className="text-22 fw-500 mb-20">
          {cruiseDetails?.response?.itinerary.itineraryName}{" "}
        </h3>

        <div className="row align-items-center y-gap-30">
          <div className="col-lg-6">
            <div className="relative">
              <div className="border-test"></div>

              <div className="accordion -map row y-gap-20">
                {cruiseDetails?.response?.itinerary.days.map((item, index) => (
                  <div className="col-12" key={index}>
                    <div
                      className={`accordion__item is-active${
                        activeIndex === index ? "is-active" : ""
                      }`}
                    >
                      <div className="d-flex">
                        <div className="accordion__icon size-40 flex-center bg-blue-2 text-blue-1 rounded-full">
                          <div className="text-14 fw-500">{item.dayNumber}</div>
                        </div>

                        <div className="ml-20">
                          <div className="text-16 lh-15 fw-500">
                            {item.dayTitle}
                          </div>

                          {activeIndex === index && (
                            <div
                              className="accordion__content"
                              style={{
                                maxHeight: "100%",
                                position: "relative",
                              }}
                            >
                              <div className="pt-15 pb-15">
                                {/* <img
													  src={item.dayPhoto}
													  alt={item.dayTitleName}
													  className="rounded-4 mt-15"
													/> */}
                                <div
                                  className="text-14 lh-17 mt-15"
                                  dangerouslySetInnerHTML={{
                                    __html: item.dayDetails,
                                  }}
                                />
                              </div>
                            </div>
                          )}

                          <div className="accordion__button">
                            <button
                              type="button"
                              className="d-block lh-15 text-14 text-blue-1 underline fw-500 mt-5"
                              onClick={() => handleAccordionToggle(index)}
                            >
                              {activeIndex === index
                                ? t("common.showLess")
                                : t("common.viewMore")}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <img
              loading="lazy"
              style={{
                borderRadius: "5px",
                boxShadow: "0px 0px 5px #ccc ",
              }}
              src={cruiseDetails?.response?.itinerary.itineraryPhoto}
              alt={t("common.itineraryMap")}
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default ItinerarySection;
